import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_PROVIDER_SALE_TAX, propTypes } from '../../util/types';
import { vatFromTransaction, rateLabel } from '../../util/vat';

import css from './BookingBreakdown.css';

// The provider's own VAT on the invoice and light paths (spec §3).
const LineItemProviderSaleTaxMaybe = props => {
  const { transaction, isProvider, intl } = props;
  if (!isProvider) return null;
  const item = transaction.attributes.lineItems.find(
    li => li.code === LINE_ITEM_PROVIDER_SALE_TAX && !li.reversal
  );
  if (!item) return null;
  const { provider } = vatFromTransaction(transaction);
  const label = rateLabel(
    { rate: Number(item.percentage) / 100, label: (provider && provider.label) || 'VAT' },
    intl.locale
  );
  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="BookingBreakdown.providerVat" values={{ rateLabel: label }} />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, item.lineTotal)}</span>
    </div>
  );
};

LineItemProviderSaleTaxMaybe.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};
export default LineItemProviderSaleTaxMaybe;
